// Classes.
import {BaseComponentLocator} from './base.component-locator';

// Interfaces.
import {ComponentLocatorInterface} from '../interfaces/component-locator.interface';


export class YearLocatorComponent extends BaseComponentLocator implements ComponentLocatorInterface {

  public constructor(protected _value: number = null) {
    super();
  };

  public toString(): string {
    let str: string;
    if (this._value === null) {
      str = 'YearNotSet';
    }
    else {
      str = this._value + '';
    }
    return str;
  }

  /**
   * value setter/getter.
   */
  set value(year: number) {
    this._value = year;
  }

  get value(): number {
    return this._value;
  }
}

